import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import { dealjacketActions, orgActions } from "../../actions";

function OrgDropdown(props) {
  const { authentication, org, getList, setCurrentOrgId, handler, prepop, clearSearch } = props;
  const current_org_id = org?.current_org_id;
  const user_id = authentication?.user_id;
  const user_is_logged_in = authentication?.loggedIn;
  const org_list = org?.list;

  const [selectedOrgId, setSelectedOrgId] = useState(1);

  /*
   * The following lines keep the org dropdown (hence current_org_id) synced with browser
   * location, so that browser back button is handled cleanly.
   */
  const path = useHistory().location.pathname;
  let id = current_org_id;
  if (path.match(/^\/org\/\d*\/.*$/)) {
    id = path.match(/^\/org\/(\d*)\/.*$/)[1];
  }
  useEffect(() => {
    if (Number(id) !== Number(current_org_id)) setCurrentOrgId(id);
  }, [id, current_org_id, setCurrentOrgId]);

  /*
   * If the user changes, then re-fech the org list.
   */
  useEffect(() => {
    if (!org_list && user_is_logged_in) {
      getList(user_id);
    }
  }, [user_id, current_org_id, user_is_logged_in, org_list, getList]);

  /*
   * Event handler for org selection from list
   */
  const onChangeOrg = (event) => {
    if (handler) {
      handler(event);
      setSelectedOrgId(event.target.value);
    } else {
      setCurrentOrgId(event.target.value);
    }
    clearSearch();
  };

  return (
    <div>
      {/* console.log('history from org dropdown: '+JSON.stringify(history))*/}
      {org.list && (
        <select
          className="orgDropdown"
          value={prepop? Number(prepop) : handler ? selectedOrgId : id ? Number(id) : org.current_org_id}
          onChange={(e) => onChangeOrg(e)}
        >
          {authentication?.user?.orgs.map((org) => (
            <option key={org.org_id} id="org" name="org" value={org.org_id}>
              {org.display_name}
            </option>
          ))}
        </select>
      )}
    </div>
  );
}

const actionCreators = {
  getList: orgActions.getList,
  setCurrentOrgId: orgActions.setCurrentOrgId,
  clearSearch: dealjacketActions.clearSearch
};

function mapStateToProps(state) {
  const { authentication, org } = state;
  return {
    authentication,
    org,
  };
}

const connectedOrgDropdown = connect(
  mapStateToProps,
  actionCreators
)(OrgDropdown);
export { connectedOrgDropdown as OrgDropdown };
